import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User, LoginRequest } from '@/constants/types';
import { authService } from '@/services/auth/authService';
import { APP_CONFIG } from '@/constants/app';

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem(APP_CONFIG.TOKEN_KEY),
  isAuthenticated: !!localStorage.getItem(APP_CONFIG.TOKEN_KEY),
  isLoading: false,
  error: null,
};

export const loginUser = createAsyncThunk(
  'auth/login',
  async (loginData: LoginRequest, { rejectWithValue }) => {
    try {
      const response = await authService.login(loginData);
      console.log(response)
      localStorage.setItem(APP_CONFIG.TOKEN_KEY, response.token);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Login failed');
    }
  }
);

export const fetchProfile = createAsyncThunk(
  'auth/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await authService.getProfile();
      return response.detail[0];
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch profile');
    }
  }
);
// export const fetchProfile = createAsyncThunk<User>(
//   'auth/fetchProfile',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await authService.getProfile();
//       var records = response.detail || [];

//       if (records.length === 0) throw new Error('Profile not found');

//       const allowedRoles = ['5', '6', '7'];

//       if (records.length > 1) {
//         const preferred = records.find(r =>
//           allowedRoles.includes(r.role_details?.RoleID)
//         );
// if(preferred){
//         records = [preferred ];
// }else{
//         records = [records[0]];

// }
//       }
// console.log(records[0])
//       return records[0];
//     } catch (error: any) {
//       return rejectWithValue(error.message || 'Failed to fetch profile');
//     }
//   }
// );


export const logoutUser = createAsyncThunk(
  'auth/logout',
  async () => {
    try {
      localStorage.removeItem(APP_CONFIG.TOKEN_KEY);
      return true;
    } catch (error: any) {
      throw error;
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem(APP_CONFIG.TOKEN_KEY, action.payload);
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem(APP_CONFIG.TOKEN_KEY);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.user = action.payload.data.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.isAuthenticated = false;
      })
      .addCase(fetchProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.isLoading = false;
          state.user = action.payload;
        // state.user = {...action.payload, role:'Booking_SuperAdmin'};
        // state.user = {...action.payload, role:'Booking_Admin'};
        // state.user = {...action.payload, role:'Booking_Viewer'};
        state.error = null;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.isLoading = false;
        state.error = null;
      });
  },
});

export const { clearError, setUser, setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;